import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const UPDATE_THIRD_PARTY_CALL_STATUS_CAP = defineCapability({
  name: 'UPDATE_THIRD_PARTY_CALL_STATUS_CAP' as const,
  args: {
    renderThirdPartyCallIcon: args.optional(args.bool()),
  },
});
